import {Lookup} from "../../models/country";

export const DeliveryBanks=[
    {
        id: "CBE",
        label: "Commerical Bank of Eritria",
        value: "CBE",
        index: 1,
        key: "CBE",
    },
    {
        id: "HCBE",
        label: "Housing and Commerce Bank of Eritrea",
        value: "HCBE",
        index: 2,
        key: "HCBE",
    },
]
export const BankBranches=[
    {
        id: "Liberty Avenue",
        label: "Liberty Avenue",
        value: "Liberty Avenue",
        index: 0,
        key: "Liberty Avenue",
        bank : 'CBE'
    },
    {
        id: "Makelai Ketema",
        label: "Makelai Ketema",
        value: "Makelai Ketema",
        index: 1,
        key: "Makelai Ketema",
        bank : 'CBE'
    },
    {
        id: "Martyrs Avenue",
        label: "Martyrs Avenue",
        value: "Martyrs Avenue",
        index: 0,
        key: "Martyrs Avenue",
        bank : 'CBE'
    },
    {
        id: "Zeray Derres Sq.",
        label: "Zeray Derres Sq.",
        value: "Zeray Derres Sq.",
        index: 0,
        key: "Zeray Derres Sq.",
        bank : 'CBE'
    },
    {
        id: "Keren",
        label: "Keren",
        value: "Keren",
        index: 0,
        key: "Keren",
        bank : 'CBE'
    },
    {
        id: "Agordat",
        label: "Agordat",
        value: "Agordat",
        index: 0,
        key: "Agordat",
        bank : 'CBE'
    },
    {
        id: "Barentu",
        label: "Barentu",
        value: "Barentu",
        index: 0,
        key: "Barentu",
        bank : 'CBE'
    },
    {
        id: "Tesenei",
        label: "Tesenei",
        value: "Tesenei",
        index: 0,
        key: "Tesenei",
        bank : 'CBE'
    },
    {
        id: "Afebet",
        label: "Afebet",
        value: "Afebet",
        index: 0,
        key: "Afebet",
        bank : 'CBE'
    },
    {
        id: "Edaga Berai",
        label: "Edaga Berai",
        value: "Edaga Berai",
        index: 0,
        key: "Edaga Berai",
        bank : 'CBE'
    },
    {
        id: "Massawa",
        label: "Massawa",
        value: "Massawa",
        index: 0,
        key: "Massawa",
        bank : 'CBE'
    },
    {
        id: "Assab",
        label: "Assab",
        value: "Assab",
        index: 0,
        key: "Assab",
        bank : 'CBE'
    },
    {
        id: "Addi Keyih",
        label: "Addi Keyih",
        value: "Addi Keyih",
        index: 0,
        key: "Addi Keyih",
        bank : 'CBE'
    },
    {
        id: "Addi Ugri",
        label: "Addi Ugri",
        value: "Addi Ugri",
        index: 0,
        key: "Addi Ugri",
        bank : 'CBE'
    },
    {
        id: "Decamhare",
        label: "Decamhare",
        value: "Decamhare",
        index: 0,
        key: "Decamhare",
        bank : 'CBE'
    },

    {
        id: "Asmara Head office",
        label: "Asmara Head office",
        value: "Asmara Head office",
        index: 0,
        key: "Asmara Head office",
        bank : 'HCBE'
    },
    {
        id: "Wushti ketema",
        label: "Wushti ketema",
        value: "Wushti ketema",
        index: 0,
        key: "Wushti ketema",
        bank : 'HCBE'
    },
    {
        id: "Sembel",
        label: "Sembel",
        value: "Sembel",
        index: 0,
        key: "Sembel",
        bank : 'HCBE'
    },
    {
        id: "Mendefera",
        label: "Mendefera",
        value: "Mendefera",
        index: 0,
        key: "Mendefera",
        bank : 'HCBE'
    },
    {
        id: "Barentu",
        label: "Barentu",
        value: "Barentu",
        index: 0,
        key: "Barentu",
        bank : 'HCBE'
    },
    {
        id: "Massawa",
        label: "Massawa",
        value: "Massawa",
        index: 0,
        key: "Massawa",
        bank : 'HCBE'
    },
    {
        id: "Assab",
        label: "Assab",
        value: "Assab",
        index: 0,
        key: "Assab",
        bank : 'HCBE'
    },
    {
        id: "Keren",
        label: "Keren",
        value: "Keren",
        index: 0,
        key: "Keren",
        bank : 'HCBE'
    },
    {
        id: "Tessenei",
        label: "Tessenei",
        value: "Tessenei",
        index: 0,
        key: "Tessenei",
        bank : 'HCBE'
    },
    {
        id: "Ghindae",
        label: "Ghindae",
        value: "Ghindae",
        index: 0,
        key: "Ghindae",
        bank : 'HCBE'
    },
    {
        id: "Nakfa",
        label: "Nakfa",
        value: "Nakfa",
        index: 0,
        key: "Nakfa",
        bank : 'HCBE'
    },
    {
        id: "Dubaruba",
        label: "Dubaruba",
        value: "Dubaruba",
        index: 0,
        key: "Dubaruba",
        bank : 'HCBE'
    },
]

export const transformedBanks= () => DeliveryBanks.map(
    (item: Lookup) => {
        return {value: item ? item.value ?? "MK" : "Not", text: item.label};
    }
);

export const transformedBankBranches=() => BankBranches.map(
    (item: any) => {
        return {value: item ? item.value ?? "MK" : "Not", text: item.label, bank:item.bank};
    }
);